import { DecimalPipe } from '@angular/common';
import { Component, inject, Input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { UUID } from '@okcargo-apps/shared-domain';
import { applyFastPaymentDiscount } from '@okcargo-apps/shared-domain-ionic';
import { ConnectivityService } from '@okcargo-apps/shared-infrastructure';

@Component({
  selector: 'lib-fastpay-freight-card-cta',
  templateUrl: './fastpay-freight-card-cta.component.html',
  styleUrls: ['./fastpay-freight-card-cta.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DecimalPipe, IonCardContent, IonButton, IonCardTitle, IonCardHeader, IonCard, TranslateModule],
})
export class FastpayFreightCardCtaComponent implements OnInit {
  private readonly modalCtrl = inject(ModalController);
  private readonly connectivity = inject(ConnectivityService);

  /** Requesting fast payment is a command: it cannot be done without connection. */
  protected readonly isOffline = this.connectivity.isOffline;

  @Input()
  originalPrice!: number;

  @Input()
  freightId!: UUID;

  @Input()
  hasEnoughDocs!: boolean;

  public showModalFastPayment = output<void>();

  public priceWithDiscount: number | undefined;

  // constructor() {}

  ngOnInit(): void {
    const { priceWithDiscount } = applyFastPaymentDiscount(this.originalPrice);
    this.priceWithDiscount = priceWithDiscount;
  }

  public showFastpayRequestModalInParent(): void {
    if (this.isOffline()) return;

    this.showModalFastPayment.emit();
  }
}
